//TO DO MAKE VANILLA
var $body = $('.js-body'),
    //body = document.querySelector('.js-body'),
		//thisPage = $body.attr('data-page'),
		//site = $body.attr('data-site'),
		height = window.innerHeight,
		width = window.innerWidth,
        scrollButton = document.querySelector('.js-scroll-down'),
        heroHeight = height,
        hero = document.querySelector('.js-hero-item'),
        header = document.querySelector(".js-header"),
        singleHeader = document.querySelector(".header--single"),
        scrollPos = 0
;
